import "./style.css";
import data from "@data/prenota.json";
import PageInSequence from "@page_templates/PageInSequence";

export default class Prenota extends PageInSequence {
  static selector = ".prenota";

  constructor(block) {
    super(block, data);
  }

  onReady() {}

  onComplete = () => {};

  onResize() {}

  onDestroy() {}
}
